/**
 * The name of the expire time variable.
 * @const {string}
 */
export const EXPIRE_TIME = 'expireTime';

/**
 * Expires in 10 minutes.
 * @const {number}
 */
export const EXPIRES_IN = 1000 * 60 * 10; // eslint-disable-line no-magic-numbers

/**
 * Expires a pending call in 1 minute.
 * @const {number}
 */
export const EXPIRES_PENDING = 1000 * 60; // eslint-disable-line no-magic-numbers

/**
 * Expires certain error calls after a short time.
 * Most errors disable caching, but some can use this value to slow down over active updates.
 *
 * @type {number}
 */
export const EXPIRES_ERROR = 1000 * 60 * 2.5; // eslint-disable-line no-magic-numbers
